import type { NormalisedPermissionAssignment as ClientResponse } from "@onhandtech/onhand-fe-shared/lib/api/common/permission-assignments/permission-assignments.types";
import { handleSuccess } from "@onhandtech/onhand-fe-shared/lib/api/common/permission-assignments/services/handle-success";
import type {
	PermissionAssignment,
	PostPermissionAssignmentPayload,
} from "@onhandtech/onhand-fe-shared/lib/contracts/api/common/permission-assignments";
import { createReduxServiceModule } from "@onhandtech/onhand-fe-shared/lib/redux";
import type { RequestArgs } from "@onhandtech/onhand-fe-shared/lib/request";
import {
	createRequestError,
	formatEndpoint,
} from "@onhandtech/onhand-fe-shared/lib/request";
import type { AxiosError } from "axios";

import { getConfig } from "../../../../../../config/configuration";

export const moduleName = "post-request-filter-set-permissions";

const args: RequestArgs<
	PermissionAssignment,
	ClientResponse,
	never,
	PostPermissionAssignmentPayload<"request_filter_set_id">
> = {
	method: "POST",
	url: formatEndpoint(getConfig().endpoints.api.v5.requestFilterSetPermissions),
	handleSuccess,
	handleFailure: (error: AxiosError) => createRequestError(error, moduleName),
};

const postRequestFilterSetPermissionAssignmentsModule = () =>
	createReduxServiceModule<
		PermissionAssignment,
		ClientResponse,
		never,
		PostPermissionAssignmentPayload<"request_filter_set_id">
	>({ moduleName, args });

export default postRequestFilterSetPermissionAssignmentsModule;
